import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const BACKEND = process.env.REACT_APP_BACKEND;

const UpdateCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    status: '1',
    image: ''
  });
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    const fetchOne = async () => {
      try {
        const res = await getRequest(`categories/${id}`);
        const item = res?.data || {};
        setFormData({
          name: item.name || '',
          status: String(item.status ?? '1'),
          image: item.image || ''
        });
      } catch (err) {
        console.error('Failed to fetch category:', err);
      }
    };
    fetchOne();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    payload.append('name', formData.name || '');
    payload.append('status', formData.status || '1');
    if (imageFile) payload.append('image', imageFile);

    try {
      await patchRequest(`categories/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Category updated successfully!');
      navigate('/categories');
    } catch (error) {
      console.error('Failed to update category:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Category</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="name">Name</label>
              <input
                id="name"
                type="text"
                name="name"
                className="form-control"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="col-sm-4 mt-2">
              <label className="admin-label" htmlFor="image">Image</label>
              <input
                id="image"
                type="file"
                className="form-control"
                onChange={(e) => setImageFile(e.target.files?.[0] || null)}
              />
            </div>
            <div className="col-sm-4 mt-2">
              {formData.image ? (
                <img
                  src={`${BACKEND}uploads/${formData.image}`}
                  alt="Current"
                  style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                />
              ) : null}
            </div>
          </div>

          <button type="submit" className="btn addbtn mt-3">
            Update
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateCategory;
